export default __webpack_public_path__ + "static/media/portfolio_800.2511e6d9.gif";